/**
 * Video Background
 **/

! function () {
    "use strict";

    function e(e, a, o) {
        // ("absolute" !== e.css("position") || "relative" !== e.css("position")) && e.css({position: "relative"}),
        e.css("background", "none"), e.append('<div class="phat-bgvideo-container" style="position:absolute;width:100%;height:100%;top:0;left:0;z-index:-2;overflow:hidden;"></div>');
        var i = e.find(".phat-bgvideo-container");
        switch (a.phatposter && i.css({
            background: "url(" + a.phatposter + ") center center",
            "background-size": "cover"
        }), i.prepend('<div class="phat-bgvideo-overlay" style="position:absolute;width:100%;height:100%;top:0;left:0;z-index:-1;"></div>'), a.phatoverlaycolor ? i.find(".phat-bgvideo-overlay").css({
            background: a.phatoverlaycolor,
            opacity: a.phatoverlayopacity
        }) : i.find(".phat-bgvideo-overlay").css({
            background: "transparent"
        }), a.phattype) {
            case "youtube":
                var r = "loop=0";
                (a.phatloop || "true" === a.phatloop) && (r = "loop=1&playlist=" + a.phatvideoid);
                var n = "";
                (a.phatmute || "true" === a.phatmute) && (n = " youtube-muted");
                var p = "autoplay=1";
                (a.phatplayonhover || "true" === a.phatplayonhover) && (p = "autoplay=0");
                var s = '<iframe id="bgvid-' + o + '" class="video-background' + n + '" style="width:100%;height:100%;" src="https://www.youtube.com/embed/' + a.phatvideoid + "?" + p + "&amp;controls=0&amp;" + r + '&amp;showinfo=0&amp;modestbranding=1&amp;disablekb=1&amp;enablejsapi=1" frameborder="0"></iframe>';
                break;
            case "vimeo":
                var r = "loop=0";
                (a.phatloop || "true" === a.phatloop) && (r = "loop=1");
                var n = "";
                (a.phatmute || "true" === a.phatmute) && (n = " vimeo-muted");
                var p = "autoplay=1";
                (a.phatplayonhover || "true" === a.phatplayonhover) && (p = "autoplay=0");
                var s = '<iframe id="bgvid-' + o + '" class="video-background' + n + '" style="width:100%;height:100%;" src="https://player.vimeo.com/video/' + a.phatvideoid + "?dnt=1&background=1" + "&" + r + "&" + p + "&player_id=bgvid-" + o + '&muted=1"></iframe>';
                break;
            case "html5":
                var r = "";
                (a.phatloop || "true" === a.phatloop) && (r = ' loop="true"');
                var n = "";
                (a.phatmute || "true" === a.phatmute) && (n = ' muted="muted"');
                var p = 'autoplay="autoplay"';
                (a.phatplayonhover || "true" === a.phatplayonhover) && (p = "");
                var s = '<video style="object-fit:cover;width:101%;height:101%;" class="video-background" preload="auto" ' + p + r + n + ">";
                a.phatmp4 && (s += '<source src="' + a.phatmp4 + '" type="video/mp4" />'), a.phatwebm && (s += '<source src="' + a.phatwebm + '" type="video/webm" />'), a.phatogv && (s += '<source src="' + a.phatogv + '" type="video/ogg" />'), s += "</video>"
        }
        $(window).width() > 1024 && (a.phatmute && "false" != a.phatmute || e.append('<a href="#" id="mute-video-' + o + '" class="mute-video mute-' + a.phattype + '" data-rel="bgvid-' + o + '" style="position:absolute;bottom:15px;left:15px;">Sound</a>'), i.prepend(s), ("youtube" === a.phattype || "vimeo" === a.phattype) && t(e, a.phatratio, a.phattype))
    }

    function t(e, t, a) {
        var o = $(window).width(),
            i = $(window).height() * .85,
            r = o / i,
            n = 16,
            p = 9;
        "4/3" === t && (n = 4, p = 3), "21/9" === t && (n = 21, p = 9);
        var s = n / p;
        if (r > s) {
            var d = r / s,
                u = 1.5 * parseInt(d * i, 10) + 300,
                h = 1.5 * parseInt(o);
            e.find("iframe.video-background").css({
                width: parseInt(h) + "px",
                height: parseInt(u) + "px",
                position: "relative",
                top: "50%",
                left: "50%",
                "-webkit-transform": "translateX(-50%) translateY(-50%)",
                "-moz-transform": "translateX(-50%) translateY(-50%)",
                "-ms-transform": "translateX(-50%) translateY(-50%)",
                "-o-transform": "translateX(-50%) translateY(-50%)",
                transform: "translateX(-50%) translateY(-50%)"
            })
        } else {
            var d = s / r,
                h = 1.25 * parseInt(d * o, 10),
                u = 1.25 * parseInt(i) + 300;
            e.find("iframe.video-background").css({
                height: parseInt(u) + "px",
                width: parseInt(h) + "px",
                position: "relative",
                top: "50%",
                left: "50%",
                "-webkit-transform": "translateX(-50%) translateY(-50%)",
                "-moz-transform": "translateX(-50%) translateY(-50%)",
                "-ms-transform": "translateX(-50%) translateY(-50%)",
                "-o-transform": "translateX(-50%) translateY(-50%)",
                transform: "translateX(-50%) translateY(-50%)"
            })
        }
    }

    function a(e) {
        var t = new YT.Player("bgvid-" + e, {
            events: {
                onReady: function () {
                    $("#bgvid-" + e).hasClass("youtube-muted") && t.mute(), $("body").on("click", "#mute-video-" + e + ".mute-video", function () {
                        t.isMuted() ? t.unMute() : t.mute()
                    }), $(".play-on-hover.videobg-id-" + e).on({
                        mouseenter: function () {
                            t.playVideo()
                        },
                        mouseleave: function () {
                            t.pauseVideo()
                        }
                    })
                }
            }
        })
    }

    function checkForFrogaloop(t) {
        if (typeof $f == 'function') {
            return $f(t);
        } else {
            setTimeout(function () {
                checkForFrogaloop(t);
            }, 25);
        }
    }

    function o(e) {
        var t = document.getElementById("bgvid-" + e);
        if (typeof $f == 'function') {
            a = $f(t);
            a.addEvent("ready", function () {
                setTimeout(function () {
                    a.api("play")
                }, 500), $(".videobg-id-" + e).hasClass("play-on-hover") && setTimeout(function () {
                    a.api("pause")
                }, 700), $("#bgvid-" + e).hasClass("vimeo-muted") && a.api("setVolume", 0), $(".play-on-hover.videobg-id-" + e).on({
                    mouseenter: function () {
                        a.api("play")
                    },
                    mouseleave: function () {
                        a.api("pause")
                    }
                })
            })
        } else {
            setTimeout(function () {
                o(e);
            }, 100);
        }
    }
    var i = document.getElementsByTagName("script")[0];
    if ($("*[data-phattype=youtube]").length > 0) {
        var r = document.createElement("script");
        r.src = "https://www.youtube.com/iframe_api", i.parentNode.insertBefore(r, i)
    }
    if ($("*[data-phattype=vimeo]").length > 0) {
        var n = document.createElement("script");
        n.src = "https://player.vimeo.com/api/player.js", i.parentNode.insertBefore(n, i)
    }! function (t) {
        t.fn.extend({
            phatVideoBg: function (i) {
                return this.each(function (r) {
                    var n = $(this),
                        p = {
                            phattype: !1,
                            phatvideoid: !1,
                            phatmp4: !1,
                            phatwebm: !1,
                            phatogv: !1,
                            phatratio: "16/9",
                            phatloop: !0,
                            phatposter: !1,
                            phatoverlaycolor: !1,
                            phatoverlayopacity: .6,
                            phatmute: !0,
                            phatplayonhover: !1
                        },
                        s = t.extend({}, p, i, n.data());
                    n.addClass("phatvideo-bg"), e(n, s, r), "youtube" === s.phattype && $(window).width() > 1024 && a(r), "vimeo" === s.phattype && $(window).width() > 1024 && o(r), s.phatplayonhover && n.addClass("play-on-hover"), n.addClass("videobg-id-" + r)
                })
            }
        })
    }($), $("body").on("click", ".mute-video", function () {
        if ($(this).hasClass("mute-html5")) {
            var e = $(this).siblings(".phat-bgvideo-container").find("video");
            0 == e.prop("muted") ? e.prop("muted", !0) : e.prop("muted", !1)
        } else if ($(this).hasClass("mute-vimeo")) {
            var t = $(this).data("rel"),
                a = document.getElementById(t),
                o = $f(a);
            $(this).hasClass("unmute") ? o.api("setVolume", 1) : o.api("setVolume", 0)
        }
        return $(this).toggleClass("unmute"), !1
    }), $("body").on("mouseenter", ".videobg-section.play-on-hover", function () {
        if ($(this).find(".phat-bgvideo-container > video").length > 0) {
            var e = $(this).find(".phat-bgvideo-container > video");
            $(e)[0].play()
        }
    }).on("mouseleave", ".videobg-section.play-on-hover", function () {
        if ($(this).find(".phat-bgvideo-container > video").length > 0) {
            var e = $(this).find(".phat-bgvideo-container > video");
            $(e)[0].pause()
        }
    })
}($);



// WEBPACK FOOTER //
// ./@modules/vendor/bg-video-player.js